import * as React from "react";
import { ArrowRight, Settings } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function PrecisionEngineeringHub() {
  return <section data-section-id="224631" id="boutique-entrance" className="relative w-full min-h-[90vh] flex items-center bg-background overflow-hidden dark">
      {}
      <style>{`
        @keyframes backgroundScroll {
          0% { background-position: 0 0; }
          100% { background-position: 48px 48px; }
        }
        .bg-grid-pattern {
          background-image: 
            linear-gradient(to right, hsl(340 82% 85% / 0.05) 1px, transparent 1px),
            linear-gradient(to bottom, hsl(340 82% 85% / 0.05) 1px, transparent 1px);
          background-size: 48px 48px;
          animation: backgroundScroll 30s linear infinite;
        }
        @keyframes slowSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-slow-spin {
          animation: slowSpin 40s linear infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-grid-pattern [mask-image:radial-gradient(ellipse_80%_60%_at_50%_50%,#000_40%,transparent_100%)]" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 py-16 lg:py-24 flex flex-col lg:flex-row items-center gap-12 lg:gap-8">
        
        {}
        <div className="flex-1 lg:w-[60%] flex flex-col gap-6 text-center lg:text-left">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-muted border border-border w-fit mx-auto lg:mx-0">
            <Settings className="size-4 text-chart-1 animate-[spin_4s_linear_infinite]" />
            <span className="text-xs font-semibold tracking-wider uppercase text-muted-foreground font-default">
              Petit Pop Toys
            </span>
          </div>
          
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] font-bold tracking-tighter uppercase text-foreground font-default leading-[1.05]">
            Fidgets, <br className="hidden sm:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-chart-1 to-chart-5">
              But Make Them Fashion
            </span>
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto lg:mx-0 font-default leading-relaxed">
            Tiny toys, big serotonin. Our collectible 3D printed fidgets are designed in Quebec to bring a pop of joy and a touch of high-fashion flair to your everyday carry and favorite obsessions.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center gap-4 mt-4 justify-center lg:justify-start">
            <Button asChild size="lg" className="w-full sm:w-auto bg-chart-1 text-primary-foreground hover:bg-chart-1/90 border-none shadow-lg shadow-chart-1/20 h-12 px-8 text-base rounded-full">
              <Link to="#">
                Shop the Collection
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-12 px-8 text-base border-border hover:bg-accent hover:text-accent-foreground rounded-full">
              <Link to="#">
                Custom Fidgets
              </Link>
            </Button>
          </div>
          
          <div className="mt-8 flex items-center justify-center lg:justify-start gap-8 text-sm font-medium text-muted-foreground">
            <div className="flex items-center gap-2">
              <div className="size-2 rounded-full bg-chart-1" />
              Designed in Quebec
            </div>
            <div className="flex items-center gap-2">
              <div className="size-2 rounded-full bg-chart-1" />
              3D Printed in Small Batches
            </div>
          </div>
        </div>

        {}
        <div className="w-full lg:w-[40%] flex justify-center items-center relative mt-12 lg:mt-0">
          {}
          <div className="absolute inset-0 bg-chart-1/10 blur-[100px] rounded-full -z-10 w-3/4 h-3/4 m-auto" />
          
          <div className="relative w-full max-w-[400px] lg:max-w-[500px] aspect-square">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1643032/img/3d_high_performance_coil_spring.png" alt="3D Render of a High-Performance Coil Spring" className="w-full h-full object-contain animate-slow-spin drop-shadow-2xl" />
            
            {}
            <div className="absolute top-10 right-10 bg-background/80 backdrop-blur-sm border border-border px-3 py-1.5 rounded-xl shadow-sm hidden md:block">
              <p className="text-xs font-mono text-foreground">Vibe: <span className="text-chart-1 font-bold">Serotonin</span></p>
            </div>
            <div className="absolute bottom-10 left-10 bg-background/80 backdrop-blur-sm border border-border px-3 py-1.5 rounded-xl shadow-sm hidden md:block">
              <p className="text-xs font-mono text-foreground">Design: <span className="text-chart-1 font-bold">Original</span></p>
            </div>
          </div>
        </div>

      </div>
    </section>;
}